import Vue from 'vue';
import { createDecorator } from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';

export function Store() {
  return (target: Vue, key: string) => {
    const metadata: any = Reflect.getMetadata('design:type', target, key);
    if (!metadata) {
      return;
    }
    createDecorator((options, key) => {
      options.mixins = options.mixins || [];

      options.mixins.push({
        beforeCreate() {
          (this as any)[key] = getModule(metadata, this.$store);
        }
      });
    })(target, key);
  };
}
